// extracted by mini-css-extract-plugin
export default {"nonCollapsibleText":"_1oqv3lf"};